export enum ItemType {
  PrevisitFormTemplateFieldConfig = 'PREVISIT_FORM_TEMPLATE_FIELD_CONFIG',
  PrevisitFormTemplateFieldConfigCondition = 'PREVISIT_FORM_TEMPLATE_FIELD_CONFIG_CONDITION',
  PrevisitFormTemplatePage = 'PREVISIT_FORM_TEMPLATE_PAGE',
  NoteTemplateDynamicConfig = 'NOTE_TEMPLATE_DYNAMIC_CONFIG',
  StandardNoteSectionProviderPreference = 'STANDARD_NOTE_SECTION_PROVIDER_PREFERENCE',
  StandardNoteFieldProviderPreference = 'STANDARD_NOTE_FIELD_PROVIDER_PREFERENCE',
  ConditionalCondition = 'CONDITIONAL_CONDITION',
}
export interface QuestionDndItem {
  index: number;
  page: number;
}

export interface CollectDrag {
  isDragging: boolean;
  canDrag: boolean;
}

export interface CollectDrop {
  isOver: boolean;
  canDrop: boolean;
}
